import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiServiceService } from '../../services/common/api-service.service';
import Swal from 'sweetalert2';



@Component({

selector:'app-merchant-about-us',

templateUrl:'./merchant-about-us.component.html',

styleUrls:['./merchant-about-us.component.scss']

})


export class MerchantAboutUsComponent implements OnInit{


aboutForm!:FormGroup;

merchantId:any;

loading=false;
isEditMode:boolean = true;

aboutData:any;



constructor(

private fb:FormBuilder,

private apiService:ApiServiceService

){}




ngOnInit(){


this.merchantId =
localStorage.getItem('merchantId');



this.createForm();


this.getAbout();



}




createForm(){


this.aboutForm=this.fb.group({

story:[
'',
Validators.required
],


speciality:[
'',
Validators.required
]


});


}






getAbout(){

  this.apiService
  .getMerchantAbout(this.merchantId)
  .subscribe({

    next:(res)=>{

      if(res.data){

        this.aboutData = res.data;

        this.aboutForm.patchValue({

          story:res.data.story,

          speciality:res.data.speciality

        });

        this.isEditMode = false;

      }

    },

    error:(err)=>{

      console.log(err);

    }

  });

}







saveAbout(){

  if(this.aboutForm.invalid){

    this.aboutForm.markAllAsTouched();

    return;

  }

  this.loading = true;

  this.apiService
  .saveMerchantAbout(
    this.merchantId,
    this.aboutForm.value
  )
  .subscribe({

    next:(res)=>{

      this.loading = false;

      this.aboutData = res.data;

      this.isEditMode = false;

      Swal.fire({

        title:'Saved',

        text:'About Us updated successfully',

        icon:'success',

        timer:1500,

        showConfirmButton:false

      });

    },

    error:(err)=>{

      this.loading = false;

      console.log(err);

    }

  });

}

editAbout(){

  this.isEditMode = true;

}


cancelEdit(){

  this.isEditMode = false;

  this.getAbout();

}


}